import { supabase } from "../supabaseClient";

const parseInvokePayload = async (data, error) => {
  if (data && typeof data === "object") return data;
  if (!error?.context?.json) return null;
  try {
    return await error.context.json();
  } catch (_) {
    return null;
  }
};

const invokePlan = async (organizationId, action, extra = {}) => {
  const { data, error } = await supabase.functions.invoke(
    "organization-billing",
    {
      body: {
        organizationId,
        action,
        returnOrigin: window.location.origin,
        ...extra,
      },
    }
  );
  const payload = await parseInvokePayload(data, error);
  if (error) {
    throw new Error(payload?.error || error.message || "Could not load the plan.");
  }
  if (payload?.error) {
    throw new Error(payload.error);
  }
  return payload;
};

export const getOrganizationPlan = (organizationId) =>
  invokePlan(organizationId, "status");

export const startOrganizationPlanCheckout = (organizationId, plan) =>
  invokePlan(organizationId, "checkout", { plan });

export const openOrganizationBillingPortal = (organizationId) =>
  invokePlan(organizationId, "portal");

export const confirmOrganizationPlanCheckout = (organizationId, sessionId) =>
  invokePlan(organizationId, "confirm", { sessionId });
